import { type SafeHtml } from 'kerfjs';

import { formatCurrencyText } from '../lib/currency-format.js';

/**
 * Locale-aware currency output for user-visible monetary values. By default it keeps up to four
 * meaningful decimals; pass `fractionDigits` to show exactly that many (e.g. `2` for spend totals).
 */
export function CurrencyAmount({
  value,
  currency,
  fractionDigits,
}: {
  value: number | null;
  currency: string;
  fractionDigits?: number;
}): SafeHtml {
  if (value === null || !Number.isFinite(value)) return <>—</>;
  return <>{formatCurrencyText(value, currency, fractionDigits)}</>;
}
